export var PROXY_SYM = Symbol.for("__rpldy-sstt-proxy__");
export var STATE_SYM = Symbol.for("__rpldy-sstt-state__");